// Variables for tcounter_terrorism_records (Tab 1)
export interface IGetCounterTerrorismRecordsParams {
  page?: number;
  pageSize?: number;
  fullName?: string;
  nationality?: string;
  modifyDateFrom?: string;
  modifyDateTo?: string;
}

export const COUNTER_TERRORISM_RECORDS_VARIABLES = {
  getAll: (params: IGetCounterTerrorismRecordsParams) => {
    const {
      page,
      pageSize,
      fullName,
      nationality,
      modifyDateFrom,
      modifyDateTo,
    } = params;
    return {
      input: {
        ...(fullName && { fullName: { contains: fullName } }),
        ...(nationality && { nationality: { contains: nationality } }),
        ...(modifyDateFrom && { modifyDate: { gte: modifyDateFrom } }),
        ...(modifyDateTo && { modifyDate: { lte: modifyDateTo } }),
      },
      ...(page && { skip: (page - 1) * (pageSize ?? 10) }),
      ...(pageSize && { take: pageSize }),
    };
  },
};

// Variables for tcounter_terrorism_faft (Tab 2)
export interface IGetCounterTerrorismFaftParams {
  page?: number;
  pageSize?: number;
  firstName?: string; // dùng chung cho search 3 tên
  nationalities?: string;
  modifyDateFrom?: string;
  modifyDateTo?: string;
}

export const COUNTER_TERRORISM_FAFT_VARIABLES = {
  getAll: (params: IGetCounterTerrorismFaftParams) => {
    const {
      page,
      pageSize,
      firstName,
      nationalities,
      modifyDateFrom,
      modifyDateTo,
    } = params;
    return {
      input: {
        // Tìm theo cả 3 trường tên: firstName, secondName, thirdName
        ...(firstName && {
          OR: [
            { firstName: { contains: firstName } },
            { secondName: { contains: firstName } },
            { thirdName: { contains: firstName } },
          ],
        }),
        ...(nationalities && { nationalities: { contains: nationalities } }),
        ...(modifyDateFrom && { modifyDate: { gte: modifyDateFrom } }),
        ...(modifyDateTo && { modifyDate: { lte: modifyDateTo } }),
      },
      ...(page && { skip: (page - 1) * (pageSize ?? 10) }),
      ...(pageSize && { take: pageSize }),
    };
  },
};

// Variables for tcounter_terrorism_peps (Tab 3)
export interface IGetCounterTerrorismPepsParams {
  page?: number;
  pageSize?: number;
  personName?: string;
  country?: string;
  modifyDateFrom?: string;
  modifyDateTo?: string;
}

export const COUNTER_TERRORISM_PEPS_VARIABLES = {
  getAll: (params: IGetCounterTerrorismPepsParams) => {
    const {
      page,
      pageSize,
      personName,
      country,
      modifyDateFrom,
      modifyDateTo,
    } = params;
    return {
      input: {
        ...(personName && { personName: { contains: personName } }),
        ...(country && { country: { contains: country } }),
        ...(modifyDateFrom && { modifyDate: { gte: modifyDateFrom } }),
        ...(modifyDateTo && { modifyDate: { lte: modifyDateTo } }),
      },
      ...(page && { skip: (page - 1) * (pageSize ?? 10) }),
      ...(pageSize && { take: pageSize }),
    };
  },
};
